import React, { useState, useEffect } from "react";
import { Card, Modal, Form, Button } from '@themesberg/react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { 
    agregarFuncionAction, 
    cerrarModalAgregarAction 
} from '../../actions/menuFuncionesActions';

export default (props) => {
    const dispatch = useDispatch();
    
    const { menu, showModalAgregar } = useSelector(state => state.menuFunciones);

    const [ funcionAgregar, guardarFuncion] = useState({
        'nombre': '',
        'url': '',
        'icono': ''
    })

    const submitAgregarFuncion = e => {
        e.preventDefault();
        
        funcionAgregar.id_menu = menu.id;
        dispatch( agregarFuncionAction(funcionAgregar) );
    }

    const handleClose = () => {
        dispatch( cerrarModalAgregarAction() );
    }

    const onChangeForm = (e) => {
        guardarFuncion({
            ...funcionAgregar,
            [e.target.name] : e.target.value
        })
    }

    return (
        <Modal as={Modal.Dialog} centered show={showModalAgregar} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title className="h6">Funciones</Modal.Title>
                <Button variant="close" aria-label="Close" onClick={handleClose} />
            </Modal.Header>
            <Form onSubmit={submitAgregarFuncion}>
            <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Nombre</Form.Label>
                        <Form.Control type="text" name="nombre" placeholder="Nombre de la función" 
                            value={funcionAgregar.nombre} onChange={onChangeForm} />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>URL</Form.Label>
                        <Form.Control type="text" name="descripcion" placeholder="URL" 
                            name="url" value={funcionAgregar.url} onChange={onChangeForm} />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Icono</Form.Label>
                        <Form.Control type="text" name="icono" placeholder="Icono" 
                            value={funcionAgregar.icono} onChange={onChangeForm} />
                    </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="link" className="text-gray ms-auto" onClick={handleClose}>
                    Cerrar
                </Button>
                <Button type="submit" variant="secondary">
                    Agregar
                </Button>
            </Modal.Footer>
            </Form>
        </Modal>
    );
}